import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {loginActivityJsonSchema, loginActivityUiSchema} from '@/services/schema/activity'
import {useAppSelector} from '@/store'

const LoginActivitySetUp = ({formData, handleFormChange}) => {
  const countryCode = useAppSelector(state => state.countryCode).countryCode

  return (
    <>
      <JsonFormsWrapper
        jsonschema={loginActivityJsonSchema(countryCode)}
        uischema={loginActivityUiSchema(countryCode)}
        data={formData}
        onChange={handleFormChange}
      />
    </>
  )
}

export default LoginActivitySetUp
